const TEMPLATE = [
  "PO Number,Master SKU,Units,Date",
  "PO-00001069,GAD-PMD-RED-ONE-001-001,1002,21/03/2025",
].join("\n");

export const downloadPtsTemplate = () => {
  const blob = new Blob([TEMPLATE], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "pts-upload-template.csv";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
